module.exports = __webpack_public_path__ + "static/media/ic_green_check.415fe2a8.svg";